import { JoiningPagesFallbacks } from "translations/src/fallbackTranslations/joining-pages";
import { JoiningPage } from "translations/src/models/joining-pages";
import { TranslationType } from "translations/src/services/joiningPages";

import { useUser } from "../context/UserContext";
import { useFetchPageTranslation } from "./useFetchPageTranslation";

export const useTranslations = <T extends JoiningPage>(
  page: T
): { texts: TranslationType<T> } => {
  const { locale } = useUser();
  const { data } = useFetchPageTranslation(page, locale);

  return { texts: data || (JoiningPagesFallbacks[page] as TranslationType<T>) };
};
